import React from "react";
import { bindActionCreators as bindActions } from "redux";
//
import { formatTime } from "../services/date";
import Screen from "./ConnectedScreen";
import PremiumAlert from "./PremiumAlert";
import Button, { ButtonBasic } from "../components/Button";

const ErrorScreen = ({
  title,
  message,
  isPremiumError,
  isTimeError,
  time,
  isActive,
  getModelsIfNeeded,
  acceptTime,
  rejectTime,
}) => {
  if (!isActive) {
    return null;
  }

  return (
    <Screen
      {...{
        title,
        isActive,
        onBack: false,
        noFooter: true,
      }}
    >
      {isPremiumError && <PremiumAlert {...{ text: message }} />}
      {!isPremiumError && (
        <p className="u-mv" dangerouslySetInnerHTML={{ __html: message }} />
      )}
      {isTimeError && (
        <div className="u-tc u-mt">
          <p>Would you like to meet for {time} instead?</p>
          <ButtonBasic title="No" onClick={rejectTime} />
          <Button title="Yes" onClick={acceptTime} className="u-ml-small" />
        </div>
      )}
      {!isTimeError && (
        <div className="u-tc">
          <ButtonBasic title="Back to results" onClick={getModelsIfNeeded} />
        </div>
      )}
    </Screen>
  );
};

// @connect
import { connect } from "react-redux";
import {
  getModelsIfNeededAction,
  acceptTimeAction,
  rejectTimeAction,
} from "../modules/models/actions";
import { getCity } from "../selectors";

const props = (state) => {
  const { booking, modal, models, ajax } = state;
  const isActive = modal.screen === "error";

  if (!isActive) {
    return {};
  }

  const { error } = ajax;

  const model = models.entities[models.active];

  const isTimeError =
    typeof error === "string" && error.indexOf("booking_time_invalid") === 0;
  let time;

  if (isTimeError) {
    const isMultiErr = error === "booking_time_invalid_multi";
    const city = getCity(state);
    const { date, newDate } = booking;

    time = formatTime(isMultiErr ? newDate : date, city.timezone);
  }

  return {
    isActive,
    isPremiumError: error === "premium",
    isTimeError,
    title: getTitle(error, model),
    message: ajax.message,
    time,
  };
};

const actions = (dispatch) =>
  bindActions(
    {
      getModelsIfNeeded: getModelsIfNeededAction,
      acceptTime: acceptTimeAction,
      rejectTime: rejectTimeAction,
    },
    dispatch
  );

export default connect(props, actions)(ErrorScreen);

// Local helpers
function getTitle(error, model) {
  if (
    typeof error === "string" &&
    error.indexOf("booking_time_invalid") === 0
  ) {
    return "Time expired";
  }

  if (error === "model_unavailable") {
    // FIXME: The real fix is to implement `shouldComponentUpdate` on ErrorScreen component
    // ErrorScreen should NOT update if `model` is not available.
    return `${model ? model.name : "Companion"} not available`;
  }

  if (error === "location_too_far") {
    // FIXME: The real fix is to implement `shouldComponentUpdate` on ErrorScreen component
    // ErrorScreen should NOT update if `model` is too far.
    return `${model ? model.name : "Companion"} too far`;
  }

  if (error === "premium") {
    return "Premium Feature";
  }

  return "Error";
}
